import { render, staticRenderFns } from "./AdministrativeVisa.vue?vue&type=template&id=0893b5da&"
import script from "./AdministrativeVisa.vue?vue&type=script&lang=js&"
export * from "./AdministrativeVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports